import _get from 'lodash/get';
import _size from 'lodash/size';
import _isEmpty from 'lodash/isEmpty';

export default function createModalFooterMessage(checked = []) {
  const hasChecked = !_isEmpty(checked);

  if (!hasChecked) return '';

  const productsCount = _size(checked);
  // const skusCount = Object.values(checked).reduce((acc, info) => {
  //   const variants = _get(info, 'variants', {});
  //   return acc + _size(variants);
  // }, 0);

  const skusCount = checked.reduce((acc, info) => {
    const variants = _get(info, 'productVariants', []);
    return acc + _size(variants);
  }, 0);

  let productsCountString = `${productsCount} product`;
  if (productsCount > 1) {
    productsCountString += 's';
  }
  let skusCountString = `${skusCount} SKU`;
  if (skusCount > 1) {
    skusCountString += 's';
  }

  return `${productsCountString} with ${skusCountString} selected`;
}
